import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { MfaEnrollmentOffer } from '../api/auth';
import { completeAuthRedirect } from './useRedirectParam';
import { clearStoredMfaEnrollmentOffer, stashMfaEnrollmentOffer } from './useMfaEnrollmentOffer';

export const useEnrollmentOfferRouting = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeToOfferOrComplete = useCallback(
    (mfaEnrollmentOffer?: MfaEnrollmentOffer) => {
      if (mfaEnrollmentOffer?.eligible) {
        stashMfaEnrollmentOffer(mfaEnrollmentOffer);
        navigate({ pathname: '/mfa/enroll', search: location.search });
        return;
      }

      // A prior session may have stashed an offer and never resolved it (skip/complete/logout
      // without revisiting). Without this, a later successful auth with no eligible offer would
      // leave that stale offer readable by MfaEnrollOfferPage's own guard if /mfa/enroll is
      // visited directly - a different user's or a stale eligibility decision.
      clearStoredMfaEnrollmentOffer();
      completeAuthRedirect();
    },
    [navigate, location.search]
  );

  return { routeToOfferOrComplete };
};
